import BasePage from './BasePage';
import { connect } from 'react-redux';
import configData from "../config.json";
import {setModalContent, setFiltersContent, setSelectedFilters} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Filters from '../components/Filters';
import Table from '../components/Table';
import $ from 'jquery';

class Signings extends BasePage {

    loadOnConstructor(){
    	this.getSignings = this.getSignings.bind(this);
    	this.newSigning = this.newSigning.bind(this);
    	this.deleteClick = this.deleteClick.bind(this);
    	this.deleteSigning = this.deleteSigning.bind(this);
    	this.deleteSigningCallback = this.deleteSigningCallback.bind(this);
    	this.clickPaginationCallback = this.clickPaginationCallback.bind(this);
    	this.parseSigingResponse = this.parseSigingResponse.bind(this);
    	this.showFilters = this.showFilters.bind(this);
	this.filterResults = this.filterResults.bind(this);
	this.excelExport = this.excelExport.bind(this);

	let startDate = new Date();
	let endDate = new Date();
	startDate.setDate(1);
	startDate.setHours(0);
	startDate.setMinutes(0);
	startDate.setSeconds(0);

	endDate.setMonth(endDate.getMonth()+1);
	endDate.setDate(0);
	endDate.setHours(23);
	endDate.setMinutes(59);
	endDate.setSeconds(59);

    	this.state = {
		canOpenFilters: false,
    		startDate, 
    		endDate 
    	};

    	this.getSignings('interface');
    }

    getSignings(type){

    	const api = this.getApi();
    	let apiParams = [
    		{name: 'page', value:this.state.page?this.state.page:1}, 
    		{name: 'limit', value: configData.rowsPerPage}
    	];

    	if(this.state.searchParams){
		apiParams = apiParams.concat(this.state.searchParams);
	}

	if(type === 'interface'){
		api.getSigningsInterface(apiParams,this.parseSigingResponse);
	}else if(type === 'download'){
		apiParams.push({name: 'export_to_file', value: 1});
		api.downloadSignings(apiParams,this.parseSigingResponse);
	}else{
		api.getSignings(apiParams,this.parseSigingResponse);
	}
    }

    excelExport(){
    	    this.setState(prevState => {
		return {
			...prevState,
			download: true
		}
	    },this.getSignings.bind(this,'download'));
    }

    parseSigingResponse(response){
	    if(response.status === 'OK'){

		    response.signings = response.signings.map(sign => {
			    sign.user_name = sign.user.name+' '+sign.user.lastname;
			    const date = new Date(sign.sign_date);
			    const dateString =
				    ("0" + date.getUTCDate()).slice(-2) + "/" +
				    ("0" + (date.getUTCMonth()+1)).slice(-2) + "/" +
				    date.getUTCFullYear() + " " +
				    ("0" + date.getUTCHours()).slice(-2) + ":" +
				    ("0" + date.getUTCMinutes()).slice(-2) + ":" +
				    ("0" + date.getUTCSeconds()).slice(-2);

			    sign.formatted_sign_date = dateString;

			    return sign;
		    });

		    const users = this.state.users?this.state.users:response.users;
		    this.setState(prevState => {
			    return {
				    ...prevState,
				    totalItems: response.totalItems,
				    totalPages: response.totalPages,
				    currentPage: response.currentPage,
				    signings: response.signings,
				    users: users,
				    canOpenFilters: true,
				    canCreateExtraSigning: response.canCreateExtraSigning,
				    i18n: response.i18n
			    }
		    });

	    }else if(this.state.download){//Es download
		this.setState(prevState => {
			return {
				...prevState,
				download: 0
			}
		});

		const newBlob = new Blob([response], { type: 'application/octet-stream' });

		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            		window.navigator.msSaveOrOpenBlob(newBlob);
       		} else {
            		// For other browsers: create a link pointing to the ObjectURL containing the blob.
            		const objUrl = window.URL.createObjectURL(newBlob);

            		let link = document.createElement('a');
            		link.href = objUrl;
            		link.download = "Fichajes.xlsx";
            		link.click();

            		// For Firefox it is necessary to delay revoking the ObjectURL.
            		setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 1000);
        	}
	    }else if(response.auth === false){
		    this.navigateTo('/login');
	    }
    }

    newSigning(){
	    this.navigateTo('/edit_signing');
    }

    clickPaginationCallback(pageNumber){
	this.setState(prevState => {
		return {
			...prevState,
			page: pageNumber
		}
	}, this.getSignings);
    }

    deleteClick(event){

	this.props.setModalContent({
		title: this.getTrad('confirmAction'),
		body: [this.getTrad('doYouWantToDeleteSigning')],
		buttons: [
			{shown: 'Aceptar', close: true,  behaviour: 'main', callback: this.deleteSigning.bind(this,event.target.id)},
			{shown: 'Cancelar', behaviour: 'secondary', close: true}
		]
	});

	$("#exampleModal").modal('toggle');
    }

    deleteSigning(buttonName){
    	const parts = buttonName.split('_');

	this.setState(prevState => {
		return {
			...prevState,
			deletedSigning: parts[1]
	}});
	const api = this.getApi();
	api.deleteSigning(parts[1],this.deleteSigningCallback);
    }

    deleteSigningCallback(response){

	if(response && response.status === 'OK'){

		const signings = this.state.signings.filter(signing => { return signing._id !== this.state.deletedSigning });

		this.setState(prevState => {
			return {
				...prevState,
				signings
			}
		});
		setTimeout(() => {
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad('signingDeletedSuccessfully')],
			buttons: [
				{shown: 'Cerrar', close: true,  behaviour: 'main'}
			]
		});

		$("#exampleModal").modal('toggle');
		}, 500);
	}else{
		setTimeout(() => {
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad(response.message)],
			buttons: [
				{shown: 'Cerrar', close: true,  behaviour: 'main'}
			]
		});

		$("#exampleModal").modal('toggle');
		}, 500);
	}
    }

    showFilters(){
    	    if(!this.state.canOpenFilters) return false;
	    let selectedFilters = {
	    	    dateRange: {
			    start: new Date(this.state.startDate),
			    end: new Date(this.state.endDate),
	    	    }
	    }

	    this.props.setSelectedFilters(selectedFilters);
	    this.props.setFiltersContent({
		    title: 'Edite sus filtros',
		    users: this.state.users,
		    dates: {start: this.state.startDate, end: this.state.endDate},
		    buttons: [
		    {shown: 'Aplicar', close: true, callback: this.filterResults, behaviour: 'main'},
		    {shown: 'Cerrar', close: true}
		    ]
	    });

	    $("#filters-component").modal('toggle');
    }

    filterResults(){
	    let filters = [];

	    for(let prop in this.props.selectedFilters){
		if(prop === 'users'){
			filters.push({name: "user_in", value: this.props.selectedFilters[prop].join()})
		}
		if(prop === 'dateRange'){
			filters.push({name: "sign_date_start", value:  this.parseDateToString(this.props.selectedFilters[prop].start)});
			filters.push({name: "sign_date_end", value:  this.parseDateToString(this.props.selectedFilters[prop].end)});
		}
	    }

	    this.setState(prevState => {
		return {
			...prevState,
			page: 1,
			searchParams: filters
		}
	    }, this.getSignings);
    }

    parseDateToString(date){
	const hoursFromTimezoneOffset = (date.getTimezoneOffset()*-1) / 60;
 	let dateToString = new Date(date.getTime());
	dateToString.setHours(date.getHours()+hoursFromTimezoneOffset);

	return dateToString.getUTCFullYear() + "-" +
		("0" + (dateToString.getUTCMonth()+1)).slice(-2) + "-" +
		("0" + dateToString.getUTCDate()).slice(-2) + " " +
		("0" + dateToString.getUTCHours()).slice(-2) + ":" +
		("0" + dateToString.getUTCMinutes()).slice(-2) + ":" +
		("0" + dateToString.getUTCSeconds()).slice(-2);
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.getTrad('signingsAdmin')}</h3>
                <div className="row mb-2 mt-4">
                    <div className="col-4">
                    	{this.state.canCreateExtraSigning?<button type="button" className="btn btn-primary" onClick={this.newSigning}>
			  	Insertar fichaje
				</button>:''}
                    </div>
                    <div className="col-4 text-center">
				<button className="btn btn-secondary" onClick={this.showFilters}>Mostrar filtros</button>
                    </div>
                    <div className="col-4 text-right">
				<button className="btn btn-secondary" onClick={this.excelExport}>Exportar a excel</button>
                    </div>
                </div>
                <div className="row">
			<div className="col-12">
				<Table 
					config = {{
						items: this.state.signings,
						i18n: this.state.i18n !== undefined? this.state.i18n:[],
						mapping: [
							{original: 'user_name', shown: 'Usuario', visible: true, click:{
								url: '/edit_signing', params: [{name: 'signing_id', field: '_id' }] }},
							{original: 'formatted_sign_date', shown: 'Fecha/Hora', visible: true, click:{
								url: '/edit_signing', params: [{name: 'signing_id', field: '_id' }] }},
							{original: '_id', shown: '_id', visible: false},
							{original: '_id', button:'X', shown: 'Eliminar', visible: true, display:'button',
								prefix: 'deletesigning_', click_callback: this.deleteClick}
						],
						pagination:{
							totalItems: this.state.totalItems?this.state.totalItems:0,
							totalPages: this.state.totalPages?this.state.totalPages:1,
							currentPage: this.state.currentPage?this.state.currentPage:1,
							callback: this.clickPaginationCallback
						}
					}}
				/>
			</div>
                </div>

		<Modal />
		<Filters />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
	    selectedFilters: state.selectedFilters
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	},
	setFiltersContent(filtersContent){
	    dispatch(setFiltersContent(filtersContent));
	},
        setSelectedFilters(selectedFilters){
            dispatch(setSelectedFilters(selectedFilters));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Signings)
